import {Injectable, WritableSignal, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loading: WritableSignal<boolean> = signal(false);
  private loadingMessage: WritableSignal<string> = signal('');

  setLoading(loading: boolean) {
    this.loading.set(loading);
  }

  getLoading(): boolean {
    return this.loading();
  }

  setMessage(message: string) {
    console.log(message)
    this.loadingMessage.set(message);
  }

  getMessage(): string {
    return this.loadingMessage();
  }
}
